module.exports = __webpack_public_path__ + "static/img/Frame 3330@2x.fcef662.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pc/Frame 3330@2x.png
// module id = AZeI
// module chunks = 1